document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[id^="A1ProductHero-"]');

  sections.forEach((section) => {
    const revealItems = section.querySelectorAll('.a1-reveal-line, .a1-reveal-group > *');
    const tiltRoot = section.querySelector('[data-tilt-root]');
    const floatTarget = section.querySelector('[data-product-float]');
    const modal = section.querySelector('[data-video-modal]');
    const openBtn = section.querySelector('[data-open-video]');
    const closeBtns = section.querySelectorAll('[data-close-video]');
    const video = section.querySelector('[data-video-element]');
    const parallaxNodes = section.querySelectorAll('[data-speed]');

    // Reveal
    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          if (entry.target.classList.contains('a1-reveal-group')) {
            const children = entry.target.children;
            Array.from(children).forEach((child, index) => {
              setTimeout(() => child.classList.add('a1-is-visible'), index * 80);
            });
          } else {
            entry.target.classList.add('a1-is-visible');
          }
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.16 });

      revealItems.forEach((item, index) => {
        if (item.parentElement && item.parentElement.classList.contains('a1-reveal-group')) return;
        item.style.transitionDelay = `${Math.min(index * 70, 420)}ms`;
        revealObserver.observe(item);
      });

      section.querySelectorAll('.a1-reveal-group').forEach((group) => {
        revealObserver.observe(group);
      });
    } else {
      revealItems.forEach((item) => item.classList.add('a1-is-visible'));
    }

    // Idle float
    if (floatTarget && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let start = null;
      const animateFloat = (timestamp) => {
        if (!start) start = timestamp;
        const progress = (timestamp - start) / 1000;
        const y = Math.sin(progress * 0.9) * -10;
        const rotate = Math.sin(progress * 0.55) * 3;
        floatTarget.style.transform = `translate3d(0, ${y}px, 0) rotateZ(${rotate * 0.15}deg)`;
        requestAnimationFrame(animateFloat);
      };
      requestAnimationFrame(animateFloat);
    }

    // Tilt
    if (tiltRoot && !window.matchMedia('(hover: none)').matches) {
      let currentX = 0;
      let currentY = 0;
      let targetX = 0;
      let targetY = 0;
      let rafId = null;

      const updateTilt = () => {
        currentX += (targetX - currentX) * 0.12;
        currentY += (targetY - currentY) * 0.12;

        tiltRoot.style.transform = `perspective(1400px) rotateX(${currentY}deg) rotateY(${currentX}deg)`;

        if (Math.abs(targetX - currentX) > 0.01 || Math.abs(targetY - currentY) > 0.01) {
          rafId = requestAnimationFrame(updateTilt);
        } else {
          rafId = null;
        }
      };

      tiltRoot.addEventListener('mousemove', (event) => {
        const rect = tiltRoot.getBoundingClientRect();
        const px = (event.clientX - rect.left) / rect.width;
        const py = (event.clientY - rect.top) / rect.height;

        targetX = (px - 0.5) * 10;     // moderate tilt
        targetY = (0.5 - py) * 8;

        if (!rafId) rafId = requestAnimationFrame(updateTilt);
      });

      tiltRoot.addEventListener('mouseleave', () => {
        targetX = 0;
        targetY = 0;
        if (!rafId) rafId = requestAnimationFrame(updateTilt);
      });
    }

    // Scroll parallax
    const onScroll = () => {
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const progress = Math.max(-1, Math.min(1, (rect.top + rect.height * 0.5 - vh * 0.5) / vh));

      parallaxNodes.forEach((node) => {
        const speed = parseFloat(node.dataset.speed || '1');
        const y = progress * 28 * (1 - speed);
        node.style.transform = `translate3d(0, ${y}px, 0)`;
      });
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    // Video modal
    const openModal = () => {
      if (!modal) return;
      modal.hidden = false;
      requestAnimationFrame(() => modal.classList.add('is-open'));
      document.documentElement.style.overflow = 'hidden';
      if (video) {
        video.currentTime = 0;
      }
    };

    const closeModal = () => {
      if (!modal) return;
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (video) {
        video.pause();
      }
      setTimeout(() => {
        modal.hidden = true;
      }, 280);
    };

    if (openBtn) {
      openBtn.addEventListener('click', openModal);
    }

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });
  });
});



const isMobile = window.matchMedia('(max-width: 768px)').matches;

const floatAmount = isMobile ? 4 : 10;
const speed = isMobile ? 0.6 : 1;

const animateFloat = (t) => {
  const y = Math.sin(t * speed) * floatAmount;
  element.style.transform = `translate3d(0, ${y}px, 0)`;
};